<template>
  <div class="main">
      <van-nav-bar
      title="我的"
      :fixed='true'
    />
      <div class="head">
          <div class="top">
              <img src="@/assets/img/user.jpg" alt="">
              <div>
                  <p>账号：{{userName}}</p>
                  <p>单位：{{deptName}}</p>
              </div>
          </div>
          <div class="bottom" @click="showPicker = true">
              <div>
                  <van-icon name="setting" />
                  <span>当前单位</span>
              </div>
              <van-icon name="arrow" />
          </div>
      </div>
      <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="deptList"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
      <van-button round type="danger" size='large' @click="logout">退出登录</van-button>
  </div>
</template>

<script>
import {setToken,getCookie} from "@/utils/common";
 import { Notify,Dialog } from 'vant';
export default {
    data() {
        return {
            userName:'',
            deptName:'',
            deptList:[],
            showPicker:false,
            deptId:''
        }
    },
    created() {
        this.getAuth()
        this.getDeptMsg()
    },
    methods:{
        getAuth() {
            this.request({
                url:'/user/getAuth',
                method:'get'
            }).then((res)=>{
                if (res.data.code==1000) {
                   this.userName = res.data.result.user.userName
                   this.deptName = `[${res.data.result.user.deptId}]${res.data.result.user.deptName}`
                }
            })
        },
        // 单位信息
        getDeptMsg() {
            this.request({
                url:'/userAuth/dept/getDeptListByUserName',
                method:'get'
            }).then((res)=>{
                if (res.data.code == 1000) {
                    this.deptList = res.data.result.list
                    this.deptList.forEach(item => {
                        item.text = `[${item.deptId}]${item.deptName}`
                    });
                }
            })
  
        },
        // 切换单位
        onConfirm(val) {
            this.deptId = val.deptId;
            this.request({
                url:'/user/getAuthSwitch',
                method:'post',
                params:{deptId:this.deptId}
            }).then((res)=>{
                if (res.data.code == 1000) {
                   Notify({ type: 'success', message: '切换成功' });
                   this.showPicker = false
                   this.getAuth()
                }else {
                    Dialog.confirm({
                        title: '提示',
                        message: res.data.message,
                    }).then(()=>{
                        
                    })
                }
            })
  
        },
        logout() {
            Dialog.confirm({
                title: '提示',
                message: '确定要退出登录吗？',
            })
            .then(() => {
                let data={
                    token:getCookie('token')
                }
                this.request({
                    url:'/sso/logout',
                    method:'post',
                    data:data
                }).then((res)=>{
                    if (res.data.code === 1000 || res.data.code === 2004) {
                        Notify({ type: 'success', message: '退出成功' });
                        setToken('');
                        this.$router.push({ path: "/login?vde="+localStorage.getItem('vde')})
                    }

                })
            })
            .catch(() => {
            });

        }
    }
}
</script>

<style lang='scss' scoped>
    .main {
        padding: 0 2vw;
        box-sizing: border-box;
        margin-top: 60px;
    }
    .head {
        background:rgba(255,255,255,1);
        box-shadow:0px 3px 5px 0px rgba(51,51,51,0.05);
        border-radius:5px;
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 30px;
        .top {
            padding: 10px 15px;
           display: flex;
           align-items: center;
           border-bottom: 2px solid #f7f7f7;
           img {
               width: 70px;
           } 
           >div {
               margin-left: 15px;
               font-size: 15px;
               line-height: 24px;
               width: 250px;
               >p:nth-of-type(2) {
                   display: block;
                   width: 100%;
                   overflow: hidden;
                   text-overflow: ellipsis;
                   white-space: nowrap;
               }
           }
        }
        .bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px;
            font-size: 15px;
            line-height: 24px;
            >div {
                display: flex;
                align-items: center;
                >span {
                    margin-left: 10px;
                }
            }
        }
    }
</style>